import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileManagerService } from '../../../file-manager/file-manager.service';
import { CollageTemplateModel } from '../models/collage-template.model';
import {CollagePageModel} from '../models/collage-page.model';
import {Frame} from 'scenejs';
import {CollageModel} from '../models/collage.model';
import {Globals} from '../../../../globals';
import {CollageTemplateNameComponent, CollageTemplateNameData} from './collage-template-name/collage-template-name.component';
import {CollageTemplateTextObjectModel} from '../models/collage-template-text-object.model';
import {CollageTemplateImageModel} from '../models/collage-template-image.model';
import {CollageTemplateObjectModel} from '../models/collage-template-object.model';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {DomSanitizer} from '@angular/platform-browser';
import html2canvas from "html2canvas";

export interface CollageTemplateResult {
  selectedTemplate: CollageTemplateModel;
  hasMargins: boolean;
}

@Component({
  standalone: false,
  selector: 'app-collage-template',
  templateUrl: './collage-template.component.html',
  styleUrls: ['./collage-template.component.css']
})

export class CollageTemplateComponent implements OnInit {
  templates: CollageTemplateModel[] = [];
  template: CollageTemplateModel;
  newTemplateName: string;
  newTemplateDescription: string;
  selectedTemplate: CollageTemplateModel = null;
  hasMargin: boolean = false;
  hasLabels: boolean = false;
  color: string;
  currentPatient: string;
  tabs: CollagePageModel[] = [];
  textObjects: CollageTemplateTextObjectModel[] = [];
  imageObjects: CollageTemplateImageModel[] = [];
  collage: CollageModel = null;
  currentPatientCaseID: string;

  cols: number;

  gridByBreakpoint = {
    xl: 5,
    lg: 5,
    md: 3,
    sm: 2,
    xs: 1
  };

  constructor(
    private breakpointObserver: BreakpointObserver,
    private fileService: FileManagerService,
    public dialogRef: MatDialogRef<CollageTemplateComponent, CollageTemplateResult>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private globals: Globals,
    public nameDialog: MatDialog,
    private sanitizer: DomSanitizer
) {
    this.templates = this.data.templates;
    this.collage = this.data.collage;
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.cols = this.gridByBreakpoint.xs;
        }
        if (result.breakpoints[Breakpoints.Small]) {
          this.cols = this.gridByBreakpoint.sm;
        }
        if (result.breakpoints[Breakpoints.Medium]) {
          this.cols = this.gridByBreakpoint.md;
        }
        if (result.breakpoints[Breakpoints.Large]) {
          this.cols = this.gridByBreakpoint.lg;
        }
        if (result.breakpoints[Breakpoints.XLarge]) {
          this.cols = this.gridByBreakpoint.xl;
        }
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.currentPatient = this.globals.currentPatientId;
    this.currentPatientCaseID = this.globals.currentPatientCaseId;
    this.getImageValues(this.collage);
    this.getTextValues(this.collage);
    console.log(this.templates);
  }

  svgURL(templateIcon: string) {
    const oldUrl = 'assets/';
    const url = oldUrl + templateIcon;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private showErrorMessage(message: string) {
    this.snackBar.open(message, 'Error', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  openNameDialog(): void {
    const nameDialog = this.nameDialog.open(CollageTemplateNameComponent, {
      width: '300px',
      data: {}
    });

    nameDialog.afterClosed().subscribe((result: CollageTemplateNameData) => {
      this.newTemplateName = result.name;
      this.newTemplateDescription = result.descr;
      this.saveTemplate();
    });
  }

  getTextValues(collage) {
    this.tabs = collage.listPages;
    // tslint:disable-next-line:prefer-for-of
    for ( let i = 0; i < this.tabs.length; i++) {
      this.tabs.map(p => {
        p.listOfTextObjects.forEach(o => {
          this.textObjects.concat({
            top: o.top,
            left: o.left,
            width: o.width,
            height: o.height,
            text: this.globals.currentPatientFullName + ': ' + this.globals.currentPatientCaseId
          });
          this.hasLabels = true;
        });
      });
    }
    return this.textObjects
  }

  getImageValues(collage) {
    this.tabs = collage.listPages;
    // tslint:disable-next-line:prefer-for-of
    for ( let i = 0; i < this.tabs.length; i++) {
      this.tabs.map(p => {
        p.listOfTextObjects.forEach(o => {
          this.imageObjects.concat({
            top: o.top,
            left: o.left,
            width: o.width,
            height: o.height,
          });
        });
      });
    }
    return this.imageObjects;
  }

  loadCollage() {
    this.getImageValues(this.collage);
    this.getTextValues(this.collage);
  }

  selectTemplate(template: CollageTemplateModel) {
    this.selectedTemplate = template;
    console.log('click working:' + this.selectedTemplate.TemplateName);
  }

  applyTemplate(): void {
    // if (this.selectedTemplate === null) {
    //   this.showErrorMessage('No template selected!');
    //   return;
    // }

    this.dialogRef.close({
      selectedTemplate: this.selectedTemplate,
      hasMargins: this.hasMargin,
    });
  }

  saveTemplate(): void {
    this.collage = this.data.collage;
    const jsonObject: CollageTemplateObjectModel =
      {
        collageSize: this.collage.collageSize,
        listOfTemplateTextObjects: this.getTextValues(this.collage),
        listOfTemplateImages: this.getImageValues(this.collage),
        hasBorders: this.collage.useBorders,
        hasLabels: this.hasLabels,
      };
    const newTemplate: CollageTemplateModel = {
      CollageTemplateID: '',
      TemplateName: this.newTemplateName,
      TemplateJSON: JSON.stringify(jsonObject),
      TemplateOrder: this.templates.length + 1,
      Description: this.newTemplateDescription,
      TemplateSVGIcon: null,
      xauditTableRowID: '',
      xauditModifiedOn: null,
      xauditModifiedBy: null,
      xauditCreatedOn: null,
      xauditCreatedBy: null,
      xauditDeleted: false
    };
    this.templates.push(newTemplate);
    this.fileService.saveCollageTemplate(newTemplate).subscribe(res => {
      console.log('Saved as: ' + res);
    });
    console.log(newTemplate);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  // reset(): void {
  //   this.selectedTemplate = null;
  // }
}
